import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaFileInvoiceDollar } from 'react-icons/fa';
import { getTarjetasAnio } from './registry';
import imagenEnConstruccion from '../../../assets/images/en-construccion.svg';
import '../../../styles/components/PanelEmpresarioIndividual.css';

/**
 * Panel de la renta de un empresario individual (company.empresario_individual): una
 * tarjeta por cosa, igual que Recursos Humanos, para revisar, probar, quitar o agregar
 * cada una sin tocar las demás. Se muestra como un paso de DeclaracionRentaPage después
 * de elegir el año. La tarjeta F22 abre el mismo recorrido de la renta de cualquier
 * empresa (renta guardada, DJ, módulo), con las claves de módulo «ei_». Las tarjetas de
 * cada fuente de datos de la persona salen de la lista del año (registry.js); las que aún
 * no tienen su módulo se ven con la imagen de obra y no se abren.
 */
const PanelEmpresarioIndividual = ({ anioTributario, onAbrirF22 }) => {
    const navigate = useNavigate();

    const menuItems = [
        {
            id: 'f22',
            title: 'Formulario 22',
            description: `Empresa y persona en una sola declaración, AT ${anioTributario}`,
            icon: <FaFileInvoiceDollar />,
            onClick: onAbrirF22
        },
        ...getTarjetasAnio(anioTributario).map((tarjeta) => ({
            id: tarjeta.id,
            title: tarjeta.titulo,
            description: tarjeta.fuente,
            icon: tarjeta.icono,
            enConstruccion: tarjeta.enConstruccion,
            onClick: () => navigate(`/declaracion-renta/empresario-individual/${anioTributario}/${tarjeta.id}`)
        }))
    ];

    return (
        <div className="panel-ei-menu-grid">
            {menuItems.map((item) => (item.enConstruccion ? (
                <div key={item.id} className="panel-ei-menu-card panel-ei-menu-card--construccion" aria-disabled="true">
                    <div className="panel-ei-card-icon">
                        {item.icon}
                    </div>
                    <h3>{item.title}</h3>
                    <p className="panel-ei-fuente">{item.description}</p>
                    <div className="panel-ei-construccion">
                        <img src={imagenEnConstruccion} alt="" />
                        <span>En construcción</span>
                    </div>
                </div>
            ) : (
                <div
                    key={item.id}
                    className="panel-ei-menu-card"
                    role="button"
                    tabIndex={0}
                    onClick={item.onClick}
                    onKeyDown={(e) => e.key === 'Enter' && item.onClick()}
                >
                    <div className="panel-ei-card-icon">
                        {item.icon}
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                </div>
            )))}
        </div>
    );
};

export default PanelEmpresarioIndividual;
